import alimentacao from '../static/cartoes/vrpat/alimentacao.png';
import auto from '../static/cartoes/vrpat/auto.png';
import auxilioAlimentacao from '../static/cartoes/vrpat/auxilioalimentacao.png';
import cesta from '../static/cartoes/vrpat/cesta.png';
import compras from '../static/cartoes/vrpat/compras.png';
import cultura from '../static/cartoes/vrpat/cultura.png';
import natal from '../static/cartoes/vrpat/natal.png';
import refeicao from '../static/cartoes/vrpat/refeicao.png';
import saude from '../static/cartoes/vrpat/saude.png';
import alimentacaoCaixa from '../static/cartoes/jvcef/alimentacao.png';
import refeicaoCaixa from '../static/cartoes/jvcef/refeicao.png';

export function getImageProductByCode(codigo) {
  switch (codigo) {
    case '00027':
      return alimentacao;
    case '00031':
      return refeicao;
    case '00028':
      return auto;
    case '00030':
      return cultura;
    case '00203':
      return compras;
    case '00201':
      return cesta;
    case '00202':
      return natal;
    case '00204':
      return auxilioAlimentacao;
    case '00205':
      return saude;
    case '00270':
    case '00271':
      return refeicaoCaixa;
    case '00290':
    case '00291':
      return alimentacaoCaixa;
    default:
      return null;
  }
}
